module.exports = __webpack_public_path__ + "static/media/ga.750d3c46.svg";